# uiPromptBox
# Handles all promptBoxes
# TODO: This is only used for lesson flagging. Could replace with a modal
$(document).on 'turbo:load', ->
  new App.uiPromptBox() if $('.uiPromptBox').length

class @App.uiPromptBox
  constructor: ->
    $prompts = $('.uiPromptBox')
    $prompts.each _.bind(@_bind, this)

  _bind: (i, el) ->
    self = this
    $t = $(el)
    prompt = $t.data('prompt') or $t.attr('href')
    $prompt = undefined
    if prompt == null
      return
    prompt = normalizeSelector(prompt)
    if ($prompt = $(prompt)) and $prompt.length == 0
      return
    # main events
    $prompt.on 'open.uiPromptBox close.uiPromptBox toggle.uiPromptBox', (e) ->
      active = $prompt.is('.active')
      $prompt.toggleClass('active', !active).stop(true, true).slideToggle 450, 'easeInOutExpo'

    $t.on 'click.uiPromptBox', (e) ->
      e.preventDefault()
      $prompt.trigger 'toggle.uiPromptBox'
      if $prompt.is('.active')
        $('html, body').animate { scrollTop: 0 }, 500

    # auto grab cancel elements
    $prompt.find('.uiPromptBox-close').on 'click.uiPromptBox', (e) ->
      e.preventDefault()
      $prompt.trigger 'close.uiPromptBox'
